// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.batch-list-modal[data-v-43b193c7] {\n  text-align: center;\n  position: relative;\n}\n.batch-list-radio-container[data-v-43b193c7],\ndiv.codes[data-v-43b193c7] {\n  position: relative;\n  width: 180px;\n  margin: 0 auto;\n}\n.fixed-width[data-v-43b193c7] {\n  margin: 1rem 5rem;\n}\n.submit-btn[data-v-43b193c7] {\n  margin-top: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
